import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9857fcca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faces-sidebar" }
const _hoisted_2 = { class: "faces-sidebar__scroll" }
const _hoisted_3 = {
  key: 1,
  class: "row q-pa-sm q-col-gutter-sm"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  class: "text-center text-grey-5 text-caption q-pa-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostFacesSidebarHeader = _resolveComponent("PostFacesSidebarHeader")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_PostFaceAvatar = _resolveComponent("PostFaceAvatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PostFacesSidebarHeader, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_q_linear_progress, {
            key: 0,
            indeterminate: "",
            color: "primary"
          }))
        : _createCommentVNode("", true),
      (_ctx.faces.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faces, (face) => {
              return (_openBlock(), _createElementBlock("div", {
                key: face.id,
                class: "col-4",
                onClick: ($event: any) => (_ctx.$emit('face-click', face))
              }, [
                _createVNode(_component_PostFaceAvatar, { face: face }, null, 8, ["face"])
              ], 8, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && _ctx.faces.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No faces detected "))
        : _createCommentVNode("", true)
    ])
  ]))
}